import axios, { AxiosResponse } from 'axios';
import { getDataUrl, reportErrorSentry } from 'src/bff';
import { CarlinesWithSalesgroups } from 'src/types';

export const getSalesgroups = async (all?: boolean): Promise<CarlinesWithSalesgroups[]> => {
  try {
    const dataUrl = getDataUrl();
	const requestUrl = all ? `${dataUrl}/getSalesgroups/true` : `${dataUrl}/getSalesgroups`;

    const response: AxiosResponse<{ carlines: CarlinesWithSalesgroups[] }> = await axios.get(requestUrl);

    return response.data.carlines;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
